import { render, staticRenderFns } from "./NavbarSelectionPhone.vue?vue&type=template&id=9f71a644&scoped=true&"
import script from "./NavbarSelectionPhone.vue?vue&type=script&lang=js&"
export * from "./NavbarSelectionPhone.vue?vue&type=script&lang=js&"
import style0 from "./NavbarSelectionPhone.vue?vue&type=style&index=0&id=9f71a644&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f71a644",
  null
  
)

export default component.exports